import { Component, Input } from '@angular/core';
import { StatusAlert } from './status-alert.model';
import { AlertComponent } from '../../../alert/alert.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-status-alerts',
  template: `
    <section>
      @for (alert of alerts; track alert) {
      <sibat-alert class="sibat-alert" [type]="alert.type">
        {{ alert.messageKey | transloco }}
      </sibat-alert>
      }
    </section>
  `,
  styleUrls: ['status-alert.scss'],
  imports: [AlertComponent, TranslocoPipe],
})
export class StatusAlertsComponent {
  @Input() alerts: StatusAlert[];
}
